import { render } from "./CampaignCharts.vue?vue&type=template&id=6e81eb8b&scoped=true"
import script from "./CampaignCharts.vue?vue&type=script&lang=js"
export * from "./CampaignCharts.vue?vue&type=script&lang=js"

import "./CampaignCharts.vue?vue&type=style&index=0&id=6e81eb8b&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e81eb8b"]])

export default __exports__